import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as SlackActionMetadataKeys from 'automation-ui-action-features/actions/slack/constants/SlackActionMetadataKeys';
export default class SlackActionMetadata extends Record({
  [SlackActionMetadataKeys.ACTION_TYPE]: ActionTypes.SLACK_NOTIFICATION,
  [SlackActionMetadataKeys.TEXT]: null,
  [SlackActionMetadataKeys.CHANNEL_IDS]: [],
  [SlackActionMetadataKeys.RECIPIENT_OWNER_PROPERTIES]: [],
  [SlackActionMetadataKeys.SLACK_CHANNEL_IDS]: [],
  [SlackActionMetadataKeys.SLACK_USER_IDS]: [],
  [SlackActionMetadataKeys.OBJECT_PROPERTIES]: null
}, 'SlackActionMetadata') {}